// import CustomSearchDropdown from "../../POP/FileComp";
// import _ from "lodash";
// import { useNavigate } from "react-router-dom";
// import React, { useState, useEffect, useCallback } from "react";
// import TableCompoenent from "../components/TableCompoenent";
// import { FULL_API_BASE_URL } from "../../../Config/Config";
// import DropDown from "../../Reports/DummyReportPage/Dropdown";
// import { useDispatch, useSelector } from "react-redux";
// import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
// import Swal from "sweetalert2";
// import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
// import ErrorImg from "./../../../Assets/Images/CommanImages/Error.png";
// import FormInputs from "../DummyReportPage/FormInputs";
// import DropDownMultipleSelection from "../components/FieldsComponent";
// import DropDownCB from "../../CreateBatch/DropdownCB";
// import DropDownMultipleSearchSelection from "../components/FieldsSearchComponent";
// import { format, startOfMonth, endOfMonth, startOfWeek } from "date-fns";
// import dayjs from "dayjs";
// const mapDataToDropdownFormat = (dataArray, idField, nameField, roll_noField) => {
//   return dataArray.map((item) => ({
//     id: item[idField],
//     label: item[nameField],
//     roll_no: item[roll_noField]
//   }));
// };
// const DPPPerformance = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   pauseTimer,
//   resumeTimer,
//   dataClient,
// }) => {
//   const [searchKey, setSearchKey] = useState(""); // State for search key from CustomSearchDropdown
//   const [batchData, setBatchData] = useState([]);
//   const [subjectData, setSubjectData] = useState([]);
//   const [chapterData, setChapterData] = useState([]);
//   const [dppData, setDppData] = useState([]);
//   const [studentData, setStudentData] = useState([]); // New state for student dropdown
//   const [selectedCourseId, setSelectedCourseId] = useState("");
//   const [selectedChapters, setSelectedChapters] = useState([]);
//   const [selectedDppIds, setSelectedDppIds] = useState([]);
//   const [selectedBatches, setSelectedBatches] = useState([]);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);
//   const [fromDate, setFromDate] = useState(""); // Add this state for from_date
//   const [endDate, setEndDate] = useState("");
//   const [selectedStudents, setSelectedStudents] = useState([]); // New state for selected students
//   const [value, setValues] = useState({
//     report_title: "",
//     course_id: "",
//     batch_id: "",
//     assessment_id: "",
//     assessment_name: "",
//     description: "",
//     month: "",
//     start_month: "",
//     month: "Month to Date",
//     end_month: "",
//     subject_id: [], // Initialize as an empty array
//     chapter_id: [], // Initialize as an empty array    month: "",
//     start_month: "",
//     end_month: "",
//     subject_id: [],
//     chapter_id: [],
//   });

//   useEffect(() => {
//     if (selectedCourseId) {
//       fetchDropdownData(); // Fetch data using the selected course_id
//     }
//   }, [
//     selectedCourseId,
//     selectedBatches,
//     selectedSubjects,
//     selectedChapters,
//     selectedDppIds,
//     selectedStudents,
//   ]);

//   // Modify fetchDropdownData to include selectedCourseId
//   const [searchColumn, setSearchColumn] = useState(null); // search column

//   const handleSearchKeyChange = (key, dropdownType) => {
//     // For Chapter, DPP, and Student, check if at least 3 characters are typed
//     if (dropdownType === "chapter" || dropdownType === "dpp" || dropdownType === "student") {
//       if (key.length >= 3) {
//         setSearchKey(key);
//         setSearchColumn(dropdownType); // Use either 'chapter', 'dpp', or 'student'
//       } else {
//         setSearchKey(null); // Before 3 characters, do not search
//         setSearchColumn(null);
//       }
//     } else {
//       // For other dropdowns (Batch, Subject, etc.), set searchKey and searchColumn to null
//       setSearchKey(null);
//       setSearchColumn(null);
//     }
//   };

//   const uniqueById = (arr, idField) => {
//     return _.uniqBy(arr, idField); // Use lodash to filter out duplicate entries by idField
//   };

//   const fetchDropdownData = useCallback(
//     _.debounce(
//       async (
//         searchKey = "",
//         searchColumn = "",
//         selectedChapters = [],
//         selectedDppIds = [],
//         selectedStudents = []
//       ) => {
//         try {
//           const response = await fetch(
//             `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey-dummy/?course_id=${selectedCourseId}`,
//             {
//               method: "POST",
//               headers: {
//                 accept: "application/json",
//                 "Content-Type": "application/json",
//               },
//               body: JSON.stringify({
//                 batch_ids: selectedBatches,
//                 subject_ids: selectedSubjects,
//                 chapter_ids: selectedChapters,
//                 assessment_ids: selectedDppIds,
//                 student_ids: selectedStudents,
//                 search_key: searchKey ? searchKey : null,
//                 search_column: searchColumn ? searchColumn : null,
//               }),
//             }
//           );
//           const data = await response.json();
//           setBatchData(
//             mapDataToDropdownFormat(data.batch_list, "batch_id", "batch_name")
//           );
//           setSubjectData(
//             mapDataToDropdownFormat(
//               data.subject_list,
//               "subject_id",
//               "subject_name"
//             )
//           );
//           // setChapterData(
//           //   mapDataToDropdownFormat(
//           //     data.chapter_list,
//           //     "chapter_id",
//           //     "chapter_name"
//           //   )
//           // );
//           setChapterData(
//             uniqueById(
//               mapDataToDropdownFormat(data.chapter_list, "chapter_id", "chapter_name"),
//               "id" // Ensure unique chapter names by their ID
//             )
//           );
//           setDppData(
//             mapDataToDropdownFormat(
//               data.assessment_list,
//               "assessment_id",
//               "assessment_name"
//             )
//           );
//           setStudentData(
//             mapDataToDropdownFormat(
//               data.student_list,
//               "student_id",
//               "student_name",
//               "roll_number",
//             )
//           );

//         } catch (error) {
//           console.error("Error fetching dropdown data:", error);
//         }
//       },
//       3000
//     ),
//     [
//       selectedBatches,
//       selectedSubjects,
//       selectedChapters,
//       selectedDppIds,
//       selectedStudents,
//       selectedCourseId,
//     ]
//   );

//   useEffect(() => {
//     fetchDropdownData();
//   }, [
//     selectedBatches,
//     selectedSubjects,
//     selectedChapters,
//     selectedDppIds,
//     selectedStudents,
//     searchKey,
//     searchColumn,
//     fetchDropdownData,
//   ]);

//   useEffect(() => {
//     fetchDropdownData(
//       searchKey,
//       searchColumn,
//       selectedChapters,
//       selectedDppIds,
//       selectedStudents
//     );
//   }, [
//     searchKey,
//     searchColumn,
//     selectedChapters,
//     selectedDppIds,
//     selectedStudents,
//     selectedCourseId,
//   ]);

//   // Trigger the API call when any selected options change
//   useEffect(() => {
//     fetchDropdownData(
//       "",
//       "",
//       selectedChapters,
//       selectedDppIds,
//       selectedStudents
//     );
//   }, [
//     selectedBatches,
//     selectedSubjects,
//     selectedChapters,
//     selectedDppIds,
//     selectedStudents,
//     fetchDropdownData,
//     selectedCourseId,
//   ]);

//   const navigate = useNavigate();

//   // Single course_id (previously an array)
//   const [resultsData, setResultsData] = useState([]);
//   const dispatch = useDispatch();
//   const { coursesdata } = useSelector((state) => state.course);
//   const [headers, setHeaders] = useState([]);
//   // const [chapterData, setChapterData] = useState([]);
//   const [isApplied, setIsApplied] = useState(false);
//   const [resetKey, setResetKey] = useState(0);
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [testnamedata, setTestNameData] = useState([]);
//   const [dppNameData, setDppNameData] = useState([]); // For storing DPP Names
//   const [selectedBatchIds, setSelectedBatchIds] = useState([]); // For selected batch_ids
//   const [isVisible, setIsVisible] = useState(true); // Default to visible

//   const [selectedItems, setSelectedItems] = useState([]);
//   const showSelectAll = true;
//   const [isExpanded, setIsExpanded] = useState(false); // New state to track the expansion of the table

//   useEffect(() => {
//     const today = new Date();
//     const firstDateOfCurrentMonth = startOfMonth(today);
//     setValues({
//       ...value,
//       start_month: format(firstDateOfCurrentMonth, "yyyy-MM-dd"),
//       end_month: format(today, "yyyy-MM-dd"),
//     });
//   }, []);

//   const [disabled, setDisabled] = useState(false);
//   useEffect(() => {
//     dispatch(fetchCourseData());
//   }, [dispatch]);

//   // Fetch course data initially
//   useEffect(() => {
//     dispatch(fetchCourseData());
//   }, [dispatch]);

//   // Fetch batches when selectedCourseId changes
//   useEffect(() => {
//     if (selectedCourseId) {
//       // fetchBatchesByCourse();
//       // fetchSubjectsByCourse();
//       fetchDropdownData();
//     }
//   }, [selectedCourseId]);

//   const handleApplyOrReset = async () => {
//     if (isApplied) {
//       // Reset only table data and headers
//       setResultsData([]); // Clear the table data
//       setHeaders([]); // Clear the headers
//       setIsApplied(false); // Set the state to not applied
//       setIsColumnDivVisible(false); // Hide the column div if necessary
//     } else {
//       // Apply logic
//       setIsApplied(true);

//       // Determine from_date and end_date based on the selected date range
//       let from_date, end_date;
//       const today = new Date();

//       if (value.month === "Last Month") {
//         from_date = format(
//           startOfMonth(new Date(today.getFullYear(), today.getMonth() - 1)),
//           "yyyy-MM-dd"
//         );
//         end_date = format(
//           endOfMonth(new Date(today.getFullYear(), today.getMonth() - 1)),
//           "yyyy-MM-dd"
//         );
//       } else if (value.month === "Month to Date") {
//         from_date = format(startOfMonth(today), "yyyy-MM-dd");
//         end_date = format(today, "yyyy-MM-dd");
//       } else if (value.month === "Week to Date") {
//         from_date = format(
//           startOfWeek(today, { weekStartsOn: 1 }),
//           "yyyy-MM-dd"
//         );
//         end_date = format(today, "yyyy-MM-dd");
//       } else if (value.month === "Custom") {
//         from_date = value.start_month;
//         end_date = value.end_month;
//       } else {
//         from_date = "2020-06-14"; // Default values
//         end_date = "2024-06-14";
//       }
//       setFromDate(from_date);
//       setEndDate(end_date);

//       // Collect the selected batch_ids, subject_ids, and chapter_ids
//       const filteredBatchIds = selectedBatches
//         .filter((batch) => batch && batch.id)
//         .map((batch) => batch.id);

//       const filteredSubjectIds = selectedSubjects
//         .filter((subject) => subject && subject.id)
//         .map((subject) => subject.id);

//       const filteredChapterIds = selectedChapters
//         .filter((chapter) => chapter && chapter.id)
//         .map((chapter) => chapter.id);

//       const postData = {
//         course_id: selectedCourseId, // Send selected course ID
//         batch_ids: selectedBatches.length > 0 ? selectedBatches : [], // Send batch IDs or empty array
//         subject_ids: selectedSubjects.length > 0 ? selectedSubjects : [], // Send subject IDs or empty array
//         chapter_ids: selectedChapters.length > 0 ? selectedChapters : [], // Send chapter IDs or empty array
//       };

//       try {
//         // Perform the API POST request with the dynamic from_date and end_date
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/get-subjectwise-dpp-performance?course_id=${selectedCourseId}&from_date=${from_date} 00:00:00&end_date=${end_date} 23:59:59`,
//           {
//             method: "POST",
//             headers: {
//               accept: "application/json",
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify(postData), // Send the formatted postData
//           }
//         );

//         const data = await response.json();

//         if (!response.ok) {
//           throw new Error("Failed to fetch report data");
//         }

//         if (data.length > 0) {
//           // Set table headers from the first row and data for the table
//           setHeaders(data[0]);
//           setResultsData(data.slice(1));
//         } else {
//           // Handle no data scenario
//           setIsMessageBoxVisible(true);
//           setMessageBox(
//             <div
//               className="Container-messageBOX"
//               onMouseEnter={pauseTimer} // Use the pauseTimer passed from props
//               onMouseLeave={resumeTimer} // Use the resumeTimer passed from props
//             >
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>No results found for the selected filters.</span>
//               </div>
//             </div>
//           );
//           setActiveImg(InterogativeImg);
//         }
//       } catch (error) {
//         // Handle error scenario
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div
//             className="Container-messageBOX"
//             onMouseEnter={pauseTimer} // Use the pauseTimer passed from props
//             onMouseLeave={resumeTimer} // Use the resumeTimer passed from props
//           >
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{error.message}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(InterogativeImg);
//       }
//     }
//   };

//   // const handleApplyOrReset = async () => {
//   //   if (isApplied) {
//   //     // Reset logic
//   //     setResultsData([]); // Clear the table data
//   //     setHeaders([]); // Clear the headers
//   //     setIsApplied(false); // Set the state to not applied
//   //   } else {
//   //     setIsApplied(true);

//   //     // Determine from_date and end_date based on the selected date range
//   //     let from_date, end_date;
//   //     const today = new Date();

//   //     if (value.month === "Last Month") {
//   //       from_date = format(
//   //         startOfMonth(new Date(today.getFullYear(), today.getMonth() - 1)),
//   //         "yyyy-MM-dd"
//   //       );
//   //       end_date = format(
//   //         endOfMonth(new Date(today.getFullYear(), today.getMonth() - 1)),
//   //         "yyyy-MM-dd"
//   //       );
//   //     } else if (value.month === "Month to Date") {
//   //       from_date = format(startOfMonth(today), "yyyy-MM-dd");
//   //       end_date = format(today, "yyyy-MM-dd");
//   //     } else if (value.month === "Week to Date") {
//   //       from_date = format(
//   //         startOfWeek(today, { weekStartsOn: 1 }),
//   //         "yyyy-MM-dd"
//   //       );
//   //       end_date = format(today, "yyyy-MM-dd");
//   //     } else if (value.month === "Custom") {
//   //       from_date = value.start_month;
//   //       end_date = value.end_month;
//   //     } else {
//   //       from_date = "2020-06-14"; // Default values
//   //       end_date = "2024-06-14";
//   //     }
//   //     setFromDate(from_date);
//   //     setEndDate(end_date);

//   //     // Collect the selected batch_ids, subject_ids, and chapter_ids
//   //     const filteredBatchIds = selectedBatches
//   //       .filter((batch) => batch && batch.id)
//   //       .map((batch) => batch.id);

//   //     const filteredSubjectIds = selectedSubjects
//   //       .filter((subject) => subject && subject.id)
//   //       .map((subject) => subject.id);

//   //     const filteredChapterIds = selectedChapters
//   //       .filter((chapter) => chapter && chapter.id)
//   //       .map((chapter) => chapter.id);

//   //     const postData = {
//   //       course_id: selectedCourseId, // Send selected course ID
//   //       batch_ids: filteredBatchIds, // Send batch IDs or empty array
//   //       subject_ids: filteredSubjectIds, // Send subject IDs or empty array
//   //       chapter_ids: filteredChapterIds, // Send chapter IDs or empty array
//   //     };

//   //     try {
//   //       // Perform the API POST request with the dynamic from_date and end_date
//   //       const response = await fetch(
//   //         `${FULL_API_BASE_URL}/get-subjectwise-dpp-performance?course_id=${selectedCourseId}&from_date=${from_date} 00:00:00&end_date=${end_date} 23:59:59`,
//   //         {
//   //           method: "POST",
//   //           headers: {
//   //             accept: "application/json",
//   //             "Content-Type": "application/json",
//   //           },
//   //           body: JSON.stringify(postData), // Send the formatted postData
//   //         }
//   //       );

//   //       const data = await response.json();

//   //       if (!response.ok) {
//   //         throw new Error("Failed to fetch report data");
//   //       }

//   //       if (data.length > 0) {
//   //         // Set table headers from the first row and data for the table
//   //         setHeaders(data[0]);
//   //         setResultsData(data.slice(1));
//   //       } else {
//   //         // Handle no data scenario
//   //         setIsMessageBoxVisible(true);
//   //         setMessageBox(
//   //           <div
//   //             className="Container-messageBOX"
//   //             onMouseEnter={pauseTimer} // Use the pauseTimer passed from props
//   //             onMouseLeave={resumeTimer} // Use the resumeTimer passed from props
//   //           >
//   //             <div className="messagebox-insider1">
//   //               <div className="loader-tc"></div>
//   //               <span>No results found for the selected filters.</span>
//   //             </div>
//   //           </div>
//   //         );
//   //         setActiveImg(InterogativeImg);
//   //       }
//   //     } catch (error) {
//   //       // Handle error scenario
//   //       setIsMessageBoxVisible(true);
//   //       setMessageBox(
//   //         <div
//   //           className="Container-messageBOX"
//   //           onMouseEnter={pauseTimer} // Use the pauseTimer passed from props
//   //           onMouseLeave={resumeTimer} // Use the resumeTimer passed from props
//   //         >
//   //           <div className="messagebox-insider1">
//   //             <div className="loader-tc"></div>
//   //             <span>{error.message}</span>
//   //           </div>
//   //         </div>
//   //       );
//   //       setActiveImg(InterogativeImg);
//   //     }
//   //   }
//   // };

//   const tableData = resultsData.map((row) =>
//     headers.map((header, index) => row[index])
//   );

//   const dropdownStyle = isApplied
//     ? { opacity: 0.5, pointerEvents: "none" }
//     : { opacity: 1, pointerEvents: "auto" };

//   const data = resultsData.map((student) =>
//     headers.map((header, index) => student[index])
//   );

//   useEffect(() => {
//     dispatch(fetchCourseData());
//   }, [dispatch]);

//   const handleRadioButtonChange = (selectedValue) => {
//     const today = new Date();

//     if (selectedValue === "Last Month") {
//       const firstDateLastMonth = startOfMonth(
//         new Date(today.getFullYear(), today.getMonth() - 1)
//       );
//       const lastDateLastMonth = endOfMonth(
//         new Date(today.getFullYear(), today.getMonth() - 1)
//       );
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(firstDateLastMonth, "yyyy-MM-dd"),
//         end_month: format(lastDateLastMonth, "yyyy-MM-dd"),
//       });
//     } else if (selectedValue === "Month to Date") {
//       const firstDateOfCurrentMonth = startOfMonth(today);
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(firstDateOfCurrentMonth, "yyyy-MM-dd"),
//         end_month: format(today, "yyyy-MM-dd"),
//       });
//     } else if (selectedValue === "Week to Date") {
//       const mondayOfCurrentWeek = startOfWeek(today, { weekStartsOn: 1 });
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(mondayOfCurrentWeek, "yyyy-MM-dd"),
//         end_month: format(today, "yyyy-MM-dd"),
//       });
//     } else {
//       setValues({ ...value, month: selectedValue });
//     }
//   };

//   const handleCustomRangeChange = (e, field) => {
//     const formattedDate = format(new Date(e.target.value), "yyyy-MM-dd");
//     setValues({ ...value, [field]: formattedDate });
//   };

//   const [focused, setFocused] = useState(false);

//   const handleFocus = () => {
//     setFocused(true);
//   };

//   const course =
//     coursesdata && coursesdata.length > 0
//       ? coursesdata.find((course) => course.course_id === selectedCourseId)
//         ?.course_description || ""
//       : "";

//   // const maxBatchLength = 136;
//   // const batch = (() => {
//   //   if (
//   //     selectedBatchIds.length === 0 ||
//   //     selectedBatchIds.length === batchData.length
//   //   ) {
//   //     return "All"; // If no batches or all batches are selected
//   //   }

//   //   const batchString = batchData
//   //     .filter((batch) => selectedBatchIds.includes(batch.batch_id))
//   //     .map((batch) => batch.batch_name)
//   //     .join(", ");

//   //   if (batchString.length > maxBatchLength) {
//   //     return "Multiple";
//   //   } else {
//   //     return batchString;
//   //   }
//   // })();

//   const getSelectedBatchNames = () => {
//     if (selectedBatches.length === 0 || selectedBatchIds.length === batchData.length) return 'All'; // If no batch is selected
//     const batchNames = batchData
//       .filter((batch) => selectedBatches.includes(batch.id)) // Filter based on selected batch IDs
//       .map((batch) => batch.label); // Extract batch names
//     return batchNames.join(', '); // Join them as a comma-separated string
//   };

//   // Function to get a string for selected subjects
//   // const maxSubjectLength = 136;
//   // const subject = (() => {
//   //   if (
//   //     value.subject_id.length === 0 ||
//   //     value.subject_id.length === subjectData.length
//   //   ) {
//   //     return "All"; // If no subjects or all subjects are selected
//   //   }
//   //   const subjectString = subjectData
//   //     .filter((subject) => value.subject_id.includes(subject.id))
//   //     .map((subject) => subject.label)
//   //     .join(", ");

//   //   if (subjectString.length > maxSubjectLength) {
//   //     return "Multiple";
//   //   } else {
//   //     return subjectString;
//   //   }
//   // })();

//   const getSelectedSubjectNames = () => {
//     if (selectedSubjects.length === 0 || selectedSubjects.length === subjectData.length) return 'All'; // If no subject is selected
//     const subjectNames = subjectData
//       .filter((subject) => selectedSubjects.includes(subject.id)) // Filter based on selected subject IDs
//       .map((subject) => subject.label); // Extract subject names
//     return subjectNames.join(', '); // Join them as a comma-separated string
//   };

//   // const maxStudentLength = 129;
//   // const student = (() => {
//   //   if (selectedStudents.length === 0 || selectedStudents.length === studentData.length) {
//   //     return 'All';
//   //   }
//   //   const studentString = selectedStudents
//   //     .map(student => `${student.roll_no}`)
//   //     .join(', ');

//   //   if (studentString.length > maxStudentLength) {
//   //     return 'Multiple';
//   //   } else {
//   //     return studentString;
//   //   }
//   // })();

//   // const maxChapterLength = 136;
//   // const chapter = (() => {
//   //   if (
//   //     value.chapter_id.length === 0 ||
//   //     value.chapter_id.length === chapterData.length
//   //   ) {
//   //     return "All";
//   //   }
//   //   const chapterString = chapterData
//   //     .filter((chapter) => value.chapter_id.includes(chapter.id))
//   //     .map((chapter) => chapter.label)
//   //     .join(", ");

//   //   if (chapterString.length > maxChapterLength) {
//   //     return "Multiple";
//   //   } else {
//   //     return chapterString;
//   //   }
//   // })();

//   const getSelectedChapterNames = () => {
//     if (selectedChapters.length === 0 || selectedChapters.length === chapterData.length) return 'All'; // If no chapter is selected
//     const chapterNames = chapterData
//       .filter((chapter) => selectedChapters.includes(chapter.id)) // Filter based on selected chapter IDs
//       .map((chapter) => chapter.label); // Extract chapter names
//     const chapterNamesString = chapterNames.join(', '); // Join them as a comma-separated string
//     const maxBatchLength = 129; // Maximum character limit for display
//     // If the length of the chapter names string exceeds the maxBatchLength, show "Multiple chapters selected"
//     if (chapterNamesString.length > maxBatchLength) {
//       return 'Multiple';
//     }
//     return chapterNamesString; // Otherwise, return the full string
//   };

//   const getSelectedStudentRollNumbers = () => {
//     if (selectedStudents.length === 0 || selectedStudents.length === studentData.length) return 'All'; // If no student is selected
//     const rollNumbers = studentData
//       .filter((student) => selectedStudents.includes(student.id)) // Filter based on selected student IDs
//       .map((student) => student.roll_no); // Extract student roll numbers

//     const rollNumbersString = rollNumbers.join(', '); // Join them as a comma-separated string

//     const maxBatchLength = 129; // Maximum character limit for display

//     // If the length of the roll numbers string exceeds the maxBatchLength, show "Multiple students selected"
//     if (rollNumbersString.length > maxBatchLength) {
//       return 'Multiple';
//     }
//     return rollNumbersString; // Otherwise, return the full string
//   };

//   return (
//     <>
//       <div
//         style={{
//           height: "auto",
//           width: "100%",
//           paddingLeft: "36.5px",
//           marginBottom: "40px",
//         }}
//       >
//         <div style={{ position: "sticky", top: "0" }}>
//           <div className="Header-up">
//             <span style={{ color: "#2F2E40", fontSize: "30px" }}>
//               DPP Performance Summary
//             </span>
//             <div
//               className="testreportcard-header-btn-container"
//               style={{ marginRight: "30px" }}
//             >
//               <button
//                 className="testreportcard-cancel-btn"
//                 onClick={() => navigate(-1)}
//               // onClick={handleCancel}
//               >
//                 CANCEL
//               </button>

//               <button
//                 className="testreportcard-create-btn"
//                 onClick={handleApplyOrReset}
//               >
//                 {isApplied ? "RESET" : "APPLY"}
//               </button>
//             </div>
//           </div>
//         </div>
//         <div
//           style={{
//             display: isVisible ? "block" : "none",
//             marginTop: "1vh",
//           }}
//         >
//           <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`course_${resetKey}`}
//             >
//               <DropDownCB
//                 label="Course"
//                 style={{ width: "13.5vw" }}
//                 selected={selectedCourseId}
//                 setSelected={setSelectedCourseId}
//                 options={
//                   coursesdata
//                     ? coursesdata.map((course) => ({
//                       id: course.course_id,
//                       label: course.course_description,
//                     }))
//                     : []
//                 }
//               />
//             </div>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`batch_${resetKey}`}
//             >
//               <DropDownMultipleSelection
//                 label="Select Batch"
//                 width="13vw"
//                 selected={selectedBatches}
//                 setSelected={setSelectedBatches}
//                 options={batchData}
//                 showSelectAll={true}
//                 onSearchKeyChange={() => handleSearchKeyChange("", null)} // Set both searchKey and searchColumn to null for batches
//               />
//             </div>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`student_${resetKey}`}
//             >
//               <CustomSearchDropdown
//                 label="Select Student"
//                 optionsData={studentData} // Pass the student data with roll number and batch
//                 selected={selectedStudents} // Bind it to the selected students state
//                 setSelected={setSelectedStudents} // Function to update selected students
//                 placeholder="Search for Students..."
//                 isRequired={true}
//                 onSearchKeyChange={(key) => handleSearchKeyChange(key, "student")} // Set search column to 'student' when interacting with this dropdown
//               />
//             </div>
//           </div>
//         </div>
//         <div
//           style={{
//             display: isVisible ? "block" : "none",
//             marginTop: "1vh",
//           }}
//         >
//           <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`subject_${resetKey}`}
//             >
//               <DropDownMultipleSelection
//                 label="Select Subject"
//                 width="13.5vw"
//                 selected={selectedSubjects}
//                 setSelected={setSelectedSubjects}
//                 options={subjectData}
//                 showSelectAll={true}
//                 onSearchKeyChange={() => handleSearchKeyChange("", null)} // Set both searchKey and searchColumn to null for subjects
//               />
//             </div>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`chapter_${resetKey}`}
//             >
//               <CustomSearchDropdown
//                 label="Select Chapter"
//                 optionsData={chapterData}
//                 selected={selectedChapters}
//                 setSelected={setSelectedChapters}
//                 placeholder="Search for Chapters..."
//                 isRequired={true}
//                 onSearchKeyChange={(key) =>
//                   handleSearchKeyChange(key, "chapter")
//                 } // Set search column to 'chapter' when interacting with this dropdown
//               />
//             </div>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`chapter_${resetKey}`}
//             >
//               <div
//                 className="col-cs2"
//                 style={{ marginRight: "1vw", ...dropdownStyle }}
//                 key={`student_${resetKey}`}
//               >
//               </div>
//             </div>
//             <div className="col-cs2"></div>
//             <div
//               className="grid-container-radio-button"
//               style={{ ...dropdownStyle }}
//             >
//               <div className="item5">
//                 <div className="toggle-radio">
//                   <input
//                     type="radio"
//                     id="last month"
//                     name="month"
//                     value="Last Month"
//                     checked={value.month === "Last Month"}
//                     onChange={() => handleRadioButtonChange("Last Month")}
//                     disabled={disabled}
//                   />
//                   <label htmlFor="last month">Last Month</label>
//                 </div>
//               </div>
//               <div className="item6">
//                 <div className="toggle-radio">
//                   <input
//                     type="radio"
//                     id="month to date"
//                     name="month"
//                     value="Month to Date"
//                     checked={value.month === "Month to Date"}
//                     onChange={() => handleRadioButtonChange("Month to Date")}
//                     disabled={disabled}
//                   />
//                   <label htmlFor="month to date">Month to Date</label>
//                 </div>
//               </div>
//               <div className="item7">
//                 <div className="toggle-radio">
//                   <input
//                     type="radio"
//                     id="week to date"
//                     name="month"
//                     value="Week to Date"
//                     checked={value.month === "Week to Date"}
//                     onChange={() => handleRadioButtonChange("Week to Date")}
//                     disabled={disabled}
//                   />
//                   <label htmlFor="week to date">Week to Date</label>
//                 </div>
//               </div>
//               <div className="item8">
//                 <div className="toggle-radio">
//                   <input
//                     type="radio"
//                     id="custom"
//                     name="month"
//                     value="Custom"
//                     checked={value.month === "Custom"}
//                     onChange={(e) =>
//                       setValues({ ...value, month: e.target.value })
//                     }
//                     disabled={disabled}
//                   />
//                   <label htmlFor="custom">Custom</label>
//                 </div>
//               </div>
//               {value.month === "Custom" && (
//                 <>
//                   <div className="item9">
//                     <FormInputs
//                       type="date"
//                       name="start_month"
//                       value={value.start_month}
//                       onChange={(e) =>
//                         setValues({ ...value, start_month: e.target.value })
//                       }
//                       disabled={isApplied}
//                     />
//                   </div>
//                   <div className="item10">To</div>
//                   <div className="item11">
//                     <FormInputs
//                       type="date"
//                       name="end_month"
//                       value={value.end_month}
//                       onChange={(e) =>
//                         setValues({ ...value, end_month: e.target.value })
//                       }
//                       disabled={isApplied}
//                     />
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>
//         </div>
//         <div style={{ position: "relative", marginTop: "20px" }}>
//           <button
//             style={{
//               position: "absolute",
//               top: "-1px",
//               left: "50%",
//               transform: "translateX(-50%)",
//               zIndex: 1,
//               width: "60px",
//               height: "10px",
//               backgroundColor: "white",
//               border: "none",
//             }}
//             onClick={() => {
//               setIsVisible(!isVisible);
//               setIsExpanded(!isExpanded); // Toggle the isExpanded state when clicked
//             }}
//           >
//             <p style={{ fontSize: "20px", color: "black" }}>. . .</p>
//           </button>
//           <TableCompoenent
//             headers={headers.map((header) => header.substring(2))}
//             data={tableData}
//             searchPlaceholder="Search by Student Name..."
//             isColumnDivVisible={isColumnDivVisible}
//             setIsColumnDivVisible={setIsColumnDivVisible}
//             dataClient={dataClient}
//             isExpanded={isExpanded}
//             ReportPageHeader="DPP Performance Summary"
//             course={course}
//             batch={getSelectedBatchNames()}
//             subject={getSelectedSubjectNames()}
//             chapter={getSelectedChapterNames()}
//             dppName={""}
//             student={getSelectedStudentRollNumbers()}
//             date={
//               fromDate && endDate && dayjs(fromDate).isValid() && dayjs(endDate).isValid()
//                 ? `${dayjs(fromDate).format("YYYY-MM-DD")} To ${dayjs(endDate).format("YYYY-MM-DD HH:mm:ss")}`
//                 : ''
//             }
//           />
//         </div>
//       </div>
//     </>
//   );
// };

// export default DPPPerformance;

// import CustomSearchDropdown from "../../POP/FileComp";
// import _ from "lodash";
// import { useNavigate } from "react-router-dom";
// import React, { useState, useEffect, useCallback } from "react";
// import TableCompoenent from "../components/TableCompoenent";
// import { FULL_API_BASE_URL } from "../../../Config/Config";
// import DropDown from "../../Reports/DummyReportPage/Dropdown";
// import { useDispatch, useSelector } from "react-redux";
// import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
// import Swal from "sweetalert2";
// import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
// import ErrorImg from "./../../../Assets/Images/CommanImages/Error.png";
// import FormInputs from "../DummyReportPage/FormInputs";
// import DropDownMultipleSelection from "../components/FieldsComponent";
// import DropDownCB from "../../CreateBatch/DropdownCB";
// import DropDownMultipleSearchSelection from "../components/FieldsSearchComponent";
// import { format, startOfMonth, endOfMonth, startOfWeek } from "date-fns";
// import dayjs from "dayjs";

// const mapDataToDropdownFormat = (dataArray, idField, nameField, roll_noField, batch_nameField) => {
//   return dataArray.map((item) => ({
//     id: item[idField],
//     label: item[nameField],
//     Option1: item[nameField], // Student Name
//     Option2: item[roll_noField], // Roll Number
//     Option3: item[batch_nameField], // Batch Name
//     Headers1: "Student", // Header for Option1
//     Headers2: "Roll Number", // Header for Option2
//     Headers3: "Batch Name", // Header for Option3
//   }));
// };

// const mapChapterDataToDropdownFormat = (dataArray, idField, chapterField, subjectField, batchField) => {
//   return dataArray.map((item) => ({
//     id: item[idField], // Mapping chapter_id
//     label: item[chapterField], // Mapping chapter_name as label
//     Option1: item[chapterField], // Chapter Name
//     Option2: item[subjectField], // Subject Name
//     Option3: item[batchField],   // Batch Name
//     Headers1: "Chapter Name", // Header for Option1
//     Headers2: "Subject Name", // Header for Option2
//     Headers3: "Batch Name",   // Header for Option3
//   }));
// };

// const DPPPerformance = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   pauseTimer,
//   resumeTimer,
//   dataClient,
// }) => {
//   const [searchKey, setSearchKey] = useState(""); // State for search key from CustomSearchDropdown
//   const [batchData, setBatchData] = useState([]);
//   const [subjectData, setSubjectData] = useState([]);
//   const [chapterData, setChapterData] = useState([]);
//   const [dppData, setDppData] = useState([]);
//   const [studentData, setStudentData] = useState([]); // New state for student dropdown
//   const [selectedCourseId, setSelectedCourseId] = useState("");
//   const [selectedChapters, setSelectedChapters] = useState([]);
//   const [selectedDppIds, setSelectedDppIds] = useState([]);
//   const [selectedBatches, setSelectedBatches] = useState([]);
//   const [selectedSubjects, setSelectedSubjects] = useState([]);
//   const [fromDate, setFromDate] = useState(""); // Add this state for from_date
//   const [endDate, setEndDate] = useState("");
//   const [selectedStudents, setSelectedStudents] = useState([]); // New state for selected students
//   const [value, setValues] = useState({
//     report_title: "",
//     course_id: "",
//     batch_id: "",
//     assessment_id: "",
//     assessment_name: "",
//     description: "",
//     month: "",
//     start_month: "",
//     month: "Month to Date",
//     end_month: "",
//     subject_id: [],
//     chapter_id: [],
//     start_month: "",
//     end_month: "",
//     subject_id: [],
//     chapter_id: [],
//   });

//   useEffect(() => {
//     if (selectedCourseId) {
//       fetchDropdownData();
//     }
//   }, [
//     selectedCourseId,
//     selectedBatches,
//     selectedSubjects,
//     selectedChapters,
//     selectedDppIds,
//     selectedStudents,
//   ]);
//   const [searchColumn, setSearchColumn] = useState(null); // search column

//   const uniqueById = (arr, idField) => {
//     return _.uniqBy(arr, idField); // Use lodash to filter out duplicate entries by idField
//   };
//   // const fetchDropdownData = useCallback(
//   //   _.debounce(async (searchKey = "", searchColumn = "", selectedChapters = [], selectedDppIds = [], selectedStudents = []) => {
//   //     try {
//   //       const payload = {
//   //         batch_ids: selectedBatches.length > 0 ? selectedBatches : [],
//   //         subject_ids: selectedSubjects.length > 0 ? selectedSubjects : [],
//   //         chapter_ids: selectedChapters.length > 0 ? selectedChapters : [],
//   //         assessment_ids: selectedDppIds.length > 0 ? selectedDppIds : [],
//   //         student_ids: selectedStudents.length > 0 ? selectedStudents : [],
//   //         search_key: searchKey ? searchKey : null,
//   //         search_column: searchColumn ? searchColumn : null,
//   //       };

//   //       const response = await fetch(
//   //         `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey-v2/?course_id=${selectedCourseId}`,
//   //         {
//   //           method: "POST",
//   //           headers: {
//   //             accept: "application/json",
//   //             "Content-Type": "application/json",
//   //           },
//   //           body: JSON.stringify(payload),
//   //         }
//   //       );

//   //       const data = await response.json();
//   //       if (searchColumn === "chapter") {
//   //         const uniqueChapters = uniqueById(
//   //           mapChapterDataToDropdownFormat(
//   //             data.chapter_list,
//   //             "chapter_id",     // ID field for chapter
//   //             "chapter_name",   // Chapter name field
//   //             "subject_name",   // Subject name field
//   //             "batch_name"      // Batch name field
//   //           ),
//   //           "id" // Use "id" as the unique field to filter duplicates
//   //         );

//   //         setChapterData(uniqueChapters);
//   //       }
//   //       if (searchColumn === "student") {
//   //         setStudentData(mapDataToDropdownFormat(data.student_list, "student_id", "student_name", "roll_number", "batch_name"));
//   //       }
//   //       setBatchData(mapDataToDropdownFormat(data.batch_list, "batch_id", "batch_name"));
//   //       setSubjectData(mapDataToDropdownFormat(data.subject_list, "subject_id", "subject_name"));
//   //       setDppData(mapDataToDropdownFormat(data.assessment_list, "assessment_id", "assessment_name"));

//   //     } catch (error) {
//   //       console.error("Error fetching dropdown data:", error);
//   //     }
//   //   }
//   //   ),
//   //   [selectedBatches, selectedSubjects, selectedChapters, selectedDppIds, selectedStudents, selectedCourseId]
//   // );

//   const fetchDropdownData = useCallback(async () => {
//     try {
//       const response = await fetch(
//         `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey-v2/?course_id=${selectedCourseId}`,
//         {
//           method: "POST",
//           headers: {
//             accept: "application/json",
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             batch_ids: selectedBatches,
//             subject_ids: selectedSubjects,
//             chapter_ids: selectedChapters,
//             assessment_ids: selectedDppIds,
//             student_ids: selectedStudents,
//             search_key: searchKey,
//             search_column: searchColumn,
//           }),
//         }
//       );

//       const data = await response.json();

//       // Mapping data to proper format for Student and Chapter dropdowns
//       setBatchData(
//         mapDataToDropdownFormat(data.batch_list, "batch_id", "batch_name")
//       );

//       setSubjectData(
//         mapDataToDropdownFormat(data.subject_list, "subject_id", "subject_name")
//       );

//       // Ensure unique chapters by chapter_id
//       const uniqueChapters = _.uniqBy(data.chapter_list, "chapter_id");
//       setChapterData(
//         uniqueChapters.map((item) => ({
//           id: item.chapter_id,
//           chapter_name: item.chapter_name, // Field for Chapter Name
//           subject_name: item.subject_name, // Field for Subject Name
//           batch_name: item.batch_name, // Field for Batch Name
//         }))
//       );

//       // Ensure unique students by student_id
//       const uniqueStudents = _.uniqBy(data.student_list, "student_id");
//       setStudentData(
//         uniqueStudents.map((item) => ({
//           id: item.student_id,
//           student_name: item.student_name, // Field for Student Name
//           roll_number: item.roll_number, // Field for Roll Number
//           batch_name: item.batch_name, // Field for Batch Name
//         }))
//       );
//     } catch (error) {
//       console.error("Error fetching dropdown data:", error);
//     }
//   }, [
//     selectedBatches,
//     selectedSubjects,
//     selectedChapters,
//     selectedDppIds,
//     selectedStudents,
//     searchKey,
//     searchColumn,
//   ]);

//   const handleDropdownClose = () => {
//     fetchDropdownData(); // Call function to update dropdowns
//   };

//   const handleSearchKeyChange = (key, dropdownType) => {
//     if (dropdownType === "chapter") {
//       if (key.length >= 3) {
//         setSearchKey(key); // Trigger the search once 3 characters are typed
//         setSearchColumn(dropdownType); // Set the search column to 'chapter'
//       } else {
//         setSearchKey(null); // Clear the searchKey if fewer than 3 characters
//         setSearchColumn(null);
//       }
//     } else if (dropdownType === "student") {
//       if (key.length >= 3) {
//         setSearchKey(key); // Trigger the search once 3 characters are typed
//         setSearchColumn(dropdownType); // Set the search column to 'student'
//       } else {
//         setSearchKey(null); // Clear the searchKey if fewer than 3 characters
//         setSearchColumn(null);
//       }
//     }
//   };

//   const navigate = useNavigate();
//   const [resultsData, setResultsData] = useState([]);
//   const dispatch = useDispatch();
//   const { coursesdata } = useSelector((state) => state.course);
//   const [headers, setHeaders] = useState([]);
//   const [isApplied, setIsApplied] = useState(false);
//   const [resetKey, setResetKey] = useState(0);
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [selectedBatchIds, setSelectedBatchIds] = useState([]); // For selected batch_ids
//   const [isVisible, setIsVisible] = useState(true); // Default to visible
//   const [isExpanded, setIsExpanded] = useState(false); // New state to track the expansion of the table

//   useEffect(() => {
//     const today = new Date();
//     const firstDateOfCurrentMonth = startOfMonth(today);
//     setValues({
//       ...value,
//       start_month: format(firstDateOfCurrentMonth, "yyyy-MM-dd"),
//       end_month: format(today, "yyyy-MM-dd"),
//     });
//   }, []);

//   const [disabled, setDisabled] = useState(false);

//   useEffect(() => {
//     dispatch(fetchCourseData());
//   }, [dispatch]);

//   const handleApplyOrReset = async () => {
//     if (isApplied) {
//       setResultsData([]); // Clear the table data
//       setHeaders([]); // Clear the headers
//       setIsApplied(false); // Reset to not applied state
//     } else {
//       setIsApplied(true);

//       let from_date, end_date;
//       const today = new Date();

//       // Determine from_date and end_date based on the selected date range
//       if (value.month === "Last Month") {
//         from_date = format(startOfMonth(new Date(today.getFullYear(), today.getMonth() - 1)), "yyyy-MM-dd");
//         end_date = format(endOfMonth(new Date(today.getFullYear(), today.getMonth() - 1)), "yyyy-MM-dd");
//       } else if (value.month === "Month to Date") {
//         from_date = format(startOfMonth(today), "yyyy-MM-dd");
//         end_date = format(today, "yyyy-MM-dd");
//       } else if (value.month === "Week to Date") {
//         from_date = format(startOfWeek(today, { weekStartsOn: 1 }), "yyyy-MM-dd");
//         end_date = format(today, "yyyy-MM-dd");
//       } else if (value.month === "Custom") {
//         from_date = value.start_month;
//         end_date = value.end_month;
//       } else {
//         from_date = "2020-06-14";
//         end_date = "2024-06-14";
//       }
//       setFromDate(from_date);
//       setEndDate(end_date);

//       // Collect the selected batch_ids, subject_ids, chapter_ids, and student_ids
//       const filteredBatchIds = selectedBatches.filter((batch) => batch && batch.id).map((batch) => batch.id);
//       const filteredSubjectIds = selectedSubjects.filter((subject) => subject && subject.id).map((subject) => subject.id);
//       const filteredChapterIds = selectedChapters.filter((chapter) => chapter && chapter.id).map((chapter) => chapter.id);
//       const filteredStudentIds = selectedStudents.filter((student) => student && student.id).map((student) => student.id);

//       const postData = {
//         course_id: selectedCourseId,
//         batch_ids: filteredBatchIds.length > 0 ? filteredBatchIds : [], // Send empty array if none are selected
//         subject_ids: filteredSubjectIds.length > 0 ? filteredSubjectIds : [], // Send empty array if none are selected
//         chapter_ids: filteredChapterIds.length > 0 ? filteredChapterIds : [], // Send empty array if none are selected
//         student_ids: filteredStudentIds.length > 0 ? filteredStudentIds : [], // Send empty array if none are selected
//       };

//       try {
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/get-subjectwise-dpp-performance?course_id=${selectedCourseId}&from_date=${from_date} 00:00:00&end_date=${end_date} 23:59:59`,
//           {
//             method: "POST",
//             headers: {
//               accept: "application/json",
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify(postData),
//           }
//         );

//         const data = await response.json();

//         if (data.length > 0) {
//           setHeaders(data[0]);
//           setResultsData(data.slice(1));
//         } else {
//           // Handle no data scenario
//           setIsMessageBoxVisible(true);
//           setMessageBox(
//             <div className="Container-messageBOX" onMouseEnter={pauseTimer} onMouseLeave={resumeTimer}>
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>No results found for the selected filters.</span>
//               </div>
//             </div>
//           );
//           setActiveImg(InterogativeImg);
//         }
//       } catch (error) {
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div className="Container-messageBOX" onMouseEnter={pauseTimer} onMouseLeave={resumeTimer}>
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{error.message}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(InterogativeImg);
//       }
//     }
//   };

//   const tableData = resultsData.map((row) =>
//     headers.map((header, index) => row[index])
//   );

//   const dropdownStyle = isApplied
//     ? { opacity: 0.5, pointerEvents: "none" }
//     : { opacity: 1, pointerEvents: "auto" };

//   useEffect(() => {
//     dispatch(fetchCourseData());
//   }, [dispatch]);

//   const handleRadioButtonChange = (selectedValue) => {
//     const today = new Date();

//     if (selectedValue === "Last Month") {
//       const firstDateLastMonth = startOfMonth(
//         new Date(today.getFullYear(), today.getMonth() - 1)
//       );
//       const lastDateLastMonth = endOfMonth(
//         new Date(today.getFullYear(), today.getMonth() - 1)
//       );
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(firstDateLastMonth, "yyyy-MM-dd"),
//         end_month: format(lastDateLastMonth, "yyyy-MM-dd"),
//       });
//     } else if (selectedValue === "Month to Date") {
//       const firstDateOfCurrentMonth = startOfMonth(today);
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(firstDateOfCurrentMonth, "yyyy-MM-dd"),
//         end_month: format(today, "yyyy-MM-dd"),
//       });
//     } else if (selectedValue === "Week to Date") {
//       const mondayOfCurrentWeek = startOfWeek(today, { weekStartsOn: 1 });
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(mondayOfCurrentWeek, "yyyy-MM-dd"),
//         end_month: format(today, "yyyy-MM-dd"),
//       });
//     } else {
//       setValues({ ...value, month: selectedValue });
//     }
//   };

//   const course =
//     coursesdata && coursesdata.length > 0
//       ? coursesdata.find((course) => course.course_id === selectedCourseId)
//         ?.course_description || ""
//       : "";

//   const getSelectedBatchNames = () => {
//     if (selectedBatches.length === 0 || selectedBatchIds.length === batchData.length) return 'All'; // If no batch is selected
//     const batchNames = batchData
//       .filter((batch) => selectedBatches.includes(batch.id)) // Filter based on selected batch IDs
//       .map((batch) => batch.label); // Extract batch names
//     return batchNames.join(', '); // Join them as a comma-separated string
//   };

//   const getSelectedSubjectNames = () => {
//     if (selectedSubjects.length === 0 || selectedSubjects.length === subjectData.length) return 'All'; // If no subject is selected
//     const subjectNames = subjectData
//       .filter((subject) => selectedSubjects.includes(subject.id)) // Filter based on selected subject IDs
//       .map((subject) => subject.label); // Extract subject names
//     return subjectNames.join(', '); // Join them as a comma-separated string
//   };

//   const getSelectedChapterNames = () => {
//     if (selectedChapters.length === 0 || selectedChapters.length === chapterData.length) return 'All'; // If no chapter is selected
//     const chapterNames = chapterData
//       .filter((chapter) => selectedChapters.includes(chapter.id)) // Filter based on selected chapter IDs
//       .map((chapter) => chapter.label); // Extract chapter names
//     const chapterNamesString = chapterNames.join(', '); // Join them as a comma-separated string
//     const maxBatchLength = 129; // Maximum character limit for display
//     // If the length of the chapter names string exceeds the maxBatchLength, show "Multiple chapters selected"
//     if (chapterNamesString.length > maxBatchLength) {
//       return 'Multiple';
//     }
//     return chapterNamesString; // Otherwise, return the full string
//   };

//   const getSelectedStudentRollNumbers = () => {
//     if (selectedStudents.length === 0 || selectedStudents.length === studentData.length) return 'All'; // If no student is selected
//     const rollNumbers = studentData
//       .filter((student) => selectedStudents.includes(student.id)) // Filter based on selected student IDs
//       .map((student) => student.roll_no); // Extract student roll numbers
//     const rollNumbersString = rollNumbers.join(', '); // Join them as a comma-separated string
//     const maxBatchLength = 129; // Maximum character limit for display
//     // If the length of the roll numbers string exceeds the maxBatchLength, show "Multiple students selected"
//     if (rollNumbersString.length > maxBatchLength) {
//       return 'Multiple';
//     }
//     return rollNumbersString; // Otherwise, return the full string
//   };

//   return (
//     <>
//       <div
//         style={{
//           height: "auto",
//           width: "100%",
//           paddingLeft: "36.5px",
//           marginBottom: "40px",
//         }}
//       >
//         <div style={{ position: "sticky", top: "0" }}>
//           <div className="Header-up">
//             <span style={{ color: "#2F2E40", fontSize: "30px" }}>
//               DPP Performance Summary
//             </span>
//             <div
//               className="testreportcard-header-btn-container"
//               style={{ marginRight: "30px" }}
//             >
//               <button
//                 className="testreportcard-cancel-btn"
//                 onClick={() => navigate(-1)}
//               // onClick={handleCancel}
//               >
//                 CANCEL
//               </button>

//               <button
//                 className="testreportcard-create-btn"
//                 onClick={handleApplyOrReset}
//               >
//                 {isApplied ? "RESET" : "APPLY"}
//               </button>
//             </div>
//           </div>
//         </div>
//         <div
//           style={{
//             display: isVisible ? "block" : "none",
//             marginTop: "1vh",
//           }}
//         >
//           <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`course_${resetKey}`}
//             >
//               <DropDownCB
//                 label="Course"
//                 style={{ width: "13.5vw" }}
//                 selected={selectedCourseId}
//                 setSelected={setSelectedCourseId}
//                 options={
//                   coursesdata
//                     ? coursesdata.map((course) => ({
//                       id: course.course_id,
//                       label: course.course_description,
//                     }))
//                     : []
//                 }
//               />
//             </div>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`batch_${resetKey}`}
//             >
//               {/* <DropDownMultipleSelection
//                 label="Select Batch"
//                 width="13vw"
//                 selected={selectedBatches}
//                 setSelected={setSelectedBatches}
//                 options={batchData}
//                 showSelectAll={true}
//                 onSearchKeyChange={() => handleSearchKeyChange("", null)} // Set both searchKey and searchColumn to null for batches
//               /> */}
//               <DropDownMultipleSelection
//                 label="Select Batch"
//                 width="13vw"
//                 selected={selectedBatches}
//                 setSelected={setSelectedBatches}
//                 options={batchData}
//                 showSelectAll={true}
//                 onDropdownClose={handleDropdownClose} // API call after dropdown closes
//                 isRequired={false}
//               />
//             </div>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`student_${resetKey}`}
//             >
//               <CustomSearchDropdown
//                 label="Select Student"
//                 optionsData={studentData} // Pass the student data with roll number and batch
//                 selected={selectedStudents} // Bind it to the selected students state
//                 setSelected={setSelectedStudents} // Function to update selected students
//                 placeholder="Search for Students..."
//                 isRequired={true}
//                 onSearchKeyChange={(key) => handleSearchKeyChange(key, "student")} // Set search column to 'student' when interacting with this dropdown
//               />
//             </div>
//           </div>
//         </div>
//         <div
//           style={{
//             display: isVisible ? "block" : "none",
//             marginTop: "1vh",
//           }}
//         >
//           <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`subject_${resetKey}`}
//             >
//               <DropDownMultipleSelection
//                 label="Select Subject"
//                 width="13.5vw"
//                 selected={selectedSubjects}
//                 setSelected={setSelectedSubjects}
//                 options={subjectData}
//                 showSelectAll={true}
//                 onSearchKeyChange={() => handleSearchKeyChange("", null)} // Set both searchKey and searchColumn to null for subjects
//               />
//             </div>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`chapter_${resetKey}`}
//             >
//               <CustomSearchDropdown
//                 label="Select Chapter"
//                 optionsData={chapterData} // Pass the chapter data with the search feature
//                 selected={selectedChapters} // Bind it to the selected chapters state
//                 setSelected={setSelectedChapters} // Function to update selected chapters
//                 placeholder="Search for Chapters..."
//                 isRequired={true}
//                 onSearchKeyChange={(key) => handleSearchKeyChange(key, "chapter")}
//               />
//             </div>
//             <div className="col-cs2"></div>
//             <div
//               className="grid-container-radio-button"
//               style={{ marginTop: "1vh", height: "35px", ...dropdownStyle }}
//             >
//               <div className="item5">
//                 <div className="toggle-radio">
//                   <input
//                     type="radio"
//                     id="last month"
//                     name="month"
//                     value="Last Month"
//                     checked={value.month === "Last Month"}
//                     onChange={() => handleRadioButtonChange("Last Month")}
//                     disabled={disabled}
//                   />
//                   <label htmlFor="last month">Previous Month</label>
//                 </div>
//               </div>
//               <div className="item6">
//                 <div className="toggle-radio">
//                   <input
//                     type="radio"
//                     id="month to date"
//                     name="month"
//                     value="Month to Date"
//                     checked={value.month === "Month to Date"}
//                     onChange={() => handleRadioButtonChange("Month to Date")}
//                     disabled={disabled}
//                   />
//                   <label htmlFor="month to date">Month to Date</label>
//                 </div>
//               </div>
//               <div className="item7">
//                 <div className="toggle-radio">
//                   <input
//                     type="radio"
//                     id="week to date"
//                     name="month"
//                     value="Week to Date"
//                     checked={value.month === "Week to Date"}
//                     onChange={() => handleRadioButtonChange("Week to Date")}
//                     disabled={disabled}
//                   />
//                   <label htmlFor="week to date">Week to Date</label>
//                 </div>
//               </div>
//               <div className="item8">
//                 <div className="toggle-radio">
//                   <input
//                     type="radio"
//                     id="custom"
//                     name="month"
//                     value="Custom"
//                     checked={value.month === "Custom"}
//                     onChange={(e) =>
//                       setValues({ ...value, month: e.target.value })
//                     }
//                     disabled={disabled}
//                   />
//                   <label htmlFor="custom">Custom</label>
//                 </div>
//               </div>
//               {value.month === "Custom" && (
//                 <>
//                   <div className="item9">
//                     <FormInputs
//                       type="date"
//                       name="start_month"
//                       value={value.start_month}
//                       onChange={(e) =>
//                         setValues({ ...value, start_month: e.target.value })
//                       }
//                       disabled={isApplied}
//                     />
//                   </div>
//                   <div className="item10">To</div>
//                   <div className="item11">
//                     <FormInputs
//                       type="date"
//                       name="end_month"
//                       value={value.end_month}
//                       onChange={(e) =>
//                         setValues({ ...value, end_month: e.target.value })
//                       }
//                       disabled={isApplied}
//                     />
//                   </div>
//                 </>
//               )}
//             </div>
//           </div>
//         </div>
//         <div style={{ position: "relative", marginTop: "20px" }}>
//           <button
//             style={{
//               position: "absolute",
//               top: "-1px",
//               left: "50%",
//               transform: "translateX(-50%)",
//               zIndex: 1,
//               width: "60px",
//               height: "10px",
//               backgroundColor: "white",
//               border: "none",
//             }}
//             onClick={() => {
//               setIsVisible(!isVisible);
//               setIsExpanded(!isExpanded); // Toggle the isExpanded state when clicked
//             }}
//           >
//             <p style={{ fontSize: "20px", color: "black" }}>. . .</p>
//           </button>
//           <TableCompoenent
//             headers={headers.map((header) => header.substring(2))}
//             data={tableData}
//             searchPlaceholder="Search by Student Name..."
//             isColumnDivVisible={isColumnDivVisible}
//             setIsColumnDivVisible={setIsColumnDivVisible}
//             dataClient={dataClient}
//             isExpanded={isExpanded}
//             ReportPageHeader="DPP Performance Summary"
//             course={course}
//             batch={getSelectedBatchNames()}
//             subject={getSelectedSubjectNames()}
//             chapter={getSelectedChapterNames()}
//             dppName={""}
//             student={getSelectedStudentRollNumbers()}
//             date={
//               fromDate && endDate && dayjs(fromDate).isValid() && dayjs(endDate).isValid()
//                 ? `${dayjs(fromDate).format("YYYY-MM-DD")} To ${dayjs(endDate).format("YYYY-MM-DD HH:mm:ss")}`
//                 : ''
//             }
//           />
//         </div>
//       </div>
//     </>
//   );
// };

// export default DPPPerformance;

import CustomSearchDropdown from "../../POP/FileComp5";
import _ from "lodash";
import { useSearchParams } from "react-router-dom";
import React, { useState, useEffect, useCallback } from "react";
import TableCompoenent from "../components/TableCompoenent";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import { useDispatch, useSelector } from "react-redux";
import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
import DropDownCB from "../components/SingleDropdwon";
import FormInputs from "../DummyReportPage/FormInputs";
import dayjs from "dayjs";
import DropDownMultipleSelection from "../components/FieldsComponent";
import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
import ErrorImg from "./../../../Assets/Images/CommanImages/Error.png";
import { useNavigate } from "react-router-dom";
const mapDataToDropdownFormat = (dataArray, idField, nameField) => {
  // Remove duplicates from the array
  return _.uniqBy(
    dataArray.map((item) => ({
      id: item[idField],
      label: item[nameField],
    })),
    "id"
  );
};

const DPPPerformance = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  pauseTimer,
  resumeTimer,
  dataClient,
  setPagePath,
}) => {
  const dispatch = useDispatch();
  const { coursesdata } = useSelector((state) => state.course);
  const [resultsData, setResultsData] = useState([]);
  // const [selectedStudentIds, setSelectedStudentIds] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [testnamedata, setTestNameData] = useState([]);
  const [isApplied, setIsApplied] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const [isVisible, setIsVisible] = useState(true); // For toggling sections visibility
  const [disabled, setDisabled] = useState(false); // For controlling dropdown disabling
  const [selectedBatchName, setSelectedBatchName] = useState("");
  const [testname, setTestName] = useState([]);
  const [chapterName, setChapterName] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [filteredSubjects, setFilteredSubjects] = useState([]);
  const [filteredBatches, setFilteredBatches] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [batchData, setBatchData] = useState([]);
  const [subjectData, setSubjectData] = useState([]);
  const [chapterData, setChapterData] = useState([]);
  const [dppData, setDppData] = useState([]);
  const [studentData, setStudentData] = useState([]);
  const [selectedCourseId, setSelectedCourseId] = useState("");
  const [selectedChapters, setSelectedChapters] = useState([]);
  const [selectedDppIds, setSelectedDppIds] = useState([]);
  const [selectedBatches, setSelectedBatches] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [searchColumn, setSearchColumn] = useState("");
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [value, setValues] = useState({
    report_title: "",
    course_id: "",
    batch_id: "",
    assessment_id: "",
    assessment_name: "",
    description: "",
    month: "",
    start_month: "",
    month: "Month to Date",
    end_month: "",
    subject_id: [], // Initialize as an empty array
    chapter_id: [], // Initialize as an empty array    month: "",
    start_month: "",
    end_month: "",
    subject_id: [],
    chapter_id: [],
  });

  const [searchParams] = useSearchParams();
  const reportName = searchParams.get("reportName");
  // console.log('Received reportName:', reportName);

  // Modify fetchDropdownData to include selectedCourseId
  useEffect(() => {
    setPagePath("Reports > Reports Dashboard > Student Performance Report");
    if (selectedCourseId) {
      fetchDropdownData(); // Call only when selectedCourseId is updated and valid
    }
  }, [selectedCourseId]); // Trigger fetchDropdownData when selectedCourseId changes

  const fetchDropdownData = useCallback(async () => {
    try {
      if (!selectedCourseId) throw new Error("No course selected");

      const response = await fetch(
        `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey-v2/?course_id=${selectedCourseId}`,
        {
          method: "POST",
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            batch_ids: selectedBatches,
            subject_ids: selectedSubjects,
            chapter_ids: selectedChapters,
            assessment_ids: selectedDppIds,
            student_ids: selectedStudents,
            search_key: searchKey,
            search_column: searchColumn,
          }),
        }
      );

      const data = await response.json();

      setBatchData(
        mapDataToDropdownFormat(data.batch_list, "batch_id", "batch_name")
      );
      setSubjectData(
        mapDataToDropdownFormat(data.subject_list, "subject_id", "subject_name")
      );
      // Ensure unique chapters by chapter_id
      const uniqueChapters = _.uniqBy(data.chapter_list, "chapter_id");
      setChapterData(
        uniqueChapters.map((item) => ({
          id: item.chapter_id,
          chapter_name: item.chapter_name, // Field for Chapter Name
          subject_name: item.subject_name, // Field for Subject Name
          // batch_name: item.batch_name, // Field for Batch Name
        }))
      );

      setDppData(
        mapDataToDropdownFormat(
          data.assessment_list,
          "assessment_id",
          "assessment_name"
        )
      );
      const uniqueStudents = _.uniqBy(data.student_list, "student_id");
      setStudentData(
        uniqueStudents.map((item) => ({
          id: item.student_id,
          student_name: item.student_name, // Field for Student Name
          roll_number: item.roll_number, // Field for Roll Number
          batch_name: item.batch_name, // Field for Batch Name
        }))
      );
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  }, [
    selectedCourseId,
    selectedBatches,
    selectedSubjects,
    selectedChapters,
    selectedDppIds,
    selectedStudents,
    searchKey,
    searchColumn,
  ]);

  const handleDropdownClose = () => {
    fetchDropdownData();
  };

  const handleSearchKeyChange = (key, dropdownType) => {
    if (
      key.length >= 3 &&
      (dropdownType === "student" || dropdownType === "chapter")
    ) {
      setSearchKey(key);
      setSearchColumn(dropdownType);
    } else {
      setSearchKey("");
      setSearchColumn("");
    }
  };

  useEffect(() => {
    dispatch(fetchCourseData());
  }, [dispatch]);

  const calculateDates = () => {
    const today = dayjs();
    let from_date = "";
    let end_date = today.format("YYYY-MM-DD HH:mm:ss");

    switch (value.month) {
      case "Last Month":
        from_date = today
          .subtract(1, "month")
          .startOf("month")
          .format("YYYY-MM-DD HH:mm:ss");
        end_date = today
          .subtract(1, "month")
          .endOf("month")
          .format("YYYY-MM-DD HH:mm:ss");
        break;
      case "Month to Date":
        from_date = today.startOf("month").format("YYYY-MM-DD HH:mm:ss");
        break;
      case "Week to Date":
        from_date = today.startOf("week").format("YYYY-MM-DD HH:mm:ss");
        break;
      case "Custom":
        const current_time = today.format("HH:mm:ss");
        from_date = `${value.start_month} 00:00:00`;
        end_date = `${value.end_month} ${current_time}`;
        break;
      default:
        break;
    }
    return { from_date, end_date };
  };

  const { from_date, end_date } = calculateDates();

  const handleApplyOrReset = async () => {
    if (isApplied) {
      // Reset only non-essential fields while keeping the selected filters
      setResultsData([]); // Clear the table data
      setHeaders([]); // Clear the headers
      setIsApplied(false); // Set the state to not applied
      setIsColumnDivVisible(false); // Hide the column div if necessary
      setDisabled(false); // Enable dropdowns
      setResetKey((prevKey) => prevKey + 1); // Trigger key change to reset components

      // Retain the selected course, batch, chapter, subject, and date values
      setValues((prevValues) => ({
        ...prevValues,
        report_title: "",
        assessment_id: "",
        assessment_name: "",
        description: "",
        // Keep course, batch, chapter, subject, and date fields unchanged
        month: prevValues.month,
        start_month: prevValues.start_month,
        end_month: prevValues.end_month,
        course_id: prevValues.course_id,
        batch_id: prevValues.batch_id,
        subject_id: prevValues.subject_id,
        chapter_id: prevValues.chapter_id,
      }));
    } else {
      // Apply logic
      setIsApplied(true);
      setDisabled(true); // Disable dropdowns

      // Fetch the DPP Performance Data using selected filters
      const { from_date, end_date } = calculateDates(); // Use the calculateDates function to get date range

      if (!selectedCourseId) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div
            className="Container-messageBOX"
            onMouseEnter={pauseTimer}
            onMouseLeave={resumeTimer}
          >
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Please Select a Course</span>
            </div>
          </div>
        );
        setActiveImg(InterogativeImg);
        return;
      }

      const requestBody = {
        // course_id: selectedCourseId || null, // Selected course ID
        batch_ids: selectedBatches || [], // Selected batch IDs
        subject_ids: selectedSubjects || [], // Selected subject IDs
        chapter_ids: selectedChapters || [], // Selected chapter IDs
        // student_ids: selectedStudents.map(student => student.id) || [], // Selected student IDs
        student_ids: selectedStudents || [],
        // from_date: from_date, // Start date
        // end_date: end_date, // End date
      };

      try {
        // const response = await fetch(`${FULL_API_BASE_URL}/get-student-dpp-report-summary`, {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-subjectwise-dpp-performance?course_id=${selectedCourseId}&from_date=${encodeURIComponent(
            from_date
          )}&end_date=${encodeURIComponent(end_date)}`,
          {
            method: "POST",
            headers: {
              accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody), // Send selected values in the request body
          }
        );

        const data = await response.json();
        if (data && data.length > 1) {
          setHeaders(data[0]); // Set headers
          setResultsData(data.slice(1)); // Set results
        } else {
          setResultsData([]);
          setIsMessageBoxVisible(true);
          setMessageBox(
            <div
              className="Container-messageBOX"
              onMouseEnter={pauseTimer}
              onMouseLeave={resumeTimer}
            >
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>No data found for the selected date range.</span>
              </div>
            </div>
          );
          setActiveImg(InterogativeImg);
        }
      } catch (error) {
        setResultsData([]);
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div
            className="Container-messageBOX"
            onMouseEnter={pauseTimer}
            onMouseLeave={resumeTimer}
          >
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{error.message}</span>
            </div>
          </div>
        );
        setActiveImg(InterogativeImg);
      }
    }
  };

  const dropdownStyle = isApplied
    ? { opacity: 0.5, pointerEvents: "none" }
    : { opacity: 1, pointerEvents: "auto" };
  const navigate = useNavigate();

  // GET COURSE WHEN WE PRINT
  const course =
    coursesdata && coursesdata.length > 0
      ? coursesdata.find((course) => course.course_id === selectedCourseId)
          ?.course_description || ""
      : "";

  // GET BATCH WHEN WE PRINT
  const getSelectedBatchNames = () => {
    if (selectedBatches.length === 0) return "All";
    const batchNames = batchData
      .filter((batch) => selectedBatches.includes(batch.id)) // Filter based on selected batch IDs
      .map((batch) => batch.label); // Extract batch names
    return batchNames.join(", "); // Join them as a comma-separated string
  };

  // GET SUBJECT WHEN SE PRINT
  const getSelectedSubjectNames = () => {
    if (selectedSubjects.length === 0) return "All";
    const subjectNames = subjectData
      .filter((subject) => selectedSubjects.includes(subject.id))
      .map((subject) => subject.label);
    return subjectNames.join(", ");
  };

  // GET CHAPTER WHEN WE PRINT
  const getSelectedChapterNames = () => {
    if (selectedChapters.length === 0) return "All";
    const chapterNames = chapterData
      .filter((chapter) => selectedChapters.includes(chapter.id)) // Filter based on selected chapter IDs
      .map((chapter) => chapter.chapter_name); // Extract chapter names
    const chapterNamesString = chapterNames.join(", "); // Join them as a comma-separated string
    const maxBatchLength = 129; // Maximum character limit for display
    // If the length of the chapter names string exceeds the maxBatchLength, show "Multiple chapters selected"
    if (chapterNamesString.length > maxBatchLength) {
      return "Multiple";
    }
    return chapterNamesString;
  };

  // GET STUDENT WHEN WE PRINT
  const getSelectedStudentRollNumbers = () => {
    if (selectedStudents.length === 0) return "All";
    const rollNumbers = studentData
      .filter((student) => selectedStudents.includes(student.id))
      .map((student) => student.roll_number);
    const rollNumbersString = rollNumbers.join(", ");
    const maxBatchLength = 129;
    if (rollNumbersString.length > maxBatchLength) {
      return "Multiple";
    }
    return rollNumbersString;
  };

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "36.5px",
        marginBottom: "40px",
      }}
    >
      <div style={{ position: "sticky", top: "0" }}>
        <div className="Header-up">
          <span
            style={{
              color: "#2F2E40",
              fontSize: "30px",
              textTransform: "capitalize",
            }}
          >
            {reportName}
          </span>
          <div
            className="testreportcard-header-btn-container"
            style={{ marginRight: "30px" }}
          >
            <button
              className="testreportcard-cancel-btn"
              // onClick={handleCancel}
              onClick={() => {
                navigate("/report_management");
              }}
            >
              CANCEL
            </button>

            <button
              className="testreportcard-create-btn"
              onClick={handleApplyOrReset}
            >
              {isApplied ? "RESET" : "APPLY"}
            </button>
          </div>
        </div>
      </div>
      <div style={{ display: isVisible ? "block" : "none", marginTop: "1vh" }}>
        <div className="row-cs-uni">
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`course_${resetKey}`}
          >
            <DropDownCB
              label="Course"
              style={{ width: "13.5vw" }}
              selected={selectedCourseId}
              setSelected={setSelectedCourseId}
              options={
                coursesdata
                  ? coursesdata.map((course) => ({
                      id: course.course_id,
                      label: course.course_description,
                    }))
                  : []
              }
            />
          </div>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`batch_${resetKey}`}
          >
            <DropDownMultipleSelection
              label="Select Batch"
              width="13vw"
              selected={selectedBatches}
              setSelected={setSelectedBatches}
              options={batchData}
              showSelectAll={true}
              onDropdownClose={handleDropdownClose} // API call after dropdown closes
              isRequired={false}
            />
          </div>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`student_${resetKey}`}
          >
            <CustomSearchDropdown
              label="Select Student"
              optionsData={studentData}
              selected={selectedStudents}
              setSelected={setSelectedStudents}
              placeholder="Search for Students..."
              headers={["Student Name", "Roll Number", "Batch Name"]}
              optionFields={{
                option1: "student_name",
                option2: "roll_number",
                option3: "batch_name",
              }}
              onDropdownClose={handleDropdownClose}
              onSearchKeyChange={(key) => handleSearchKeyChange(key, "student")}
              customwidth="20vw"
            />
          </div>
        </div>
        <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`subject_${resetKey}`}
          >
            <DropDownMultipleSelection
              width="13.5vw"
              label="Select Subject"
              selected={selectedSubjects}
              setSelected={setSelectedSubjects}
              options={subjectData}
              customWidth="100%"
              isRequired={false}
              showSelectAll={true}
              onDropdownClose={handleDropdownClose}
            />
          </div>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`chapter_${resetKey}`}
          >
            <CustomSearchDropdown
              label="Select Chapter"
              optionsData={chapterData}
              selected={selectedChapters}
              setSelected={setSelectedChapters}
              placeholder="Search for Chapter..."
              headers={["Chapter Name", "Subject Name"]}
              optionFields={{
                option1: "chapter_name",
                option2: "subject_name",
                // option3: "batch_name",
              }}
              onDropdownClose={handleDropdownClose} // API call after dropdown closes
              onSearchKeyChange={(key) => handleSearchKeyChange(key, "chapter")}
              customwidth="20vw"
            />
          </div>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`dpp_${resetKey}`}
          ></div>
        </div>
        <div
          className="grid-container-radio-button"
          style={{ marginTop: "1vh", height: "35px", ...dropdownStyle }}
        >
          <div className="item5">
            <div className="toggle-radio">
              <input
                type="radio"
                id="last month"
                name="month"
                value="Last Month"
                checked={value.month === "Last Month"}
                onChange={(e) => setValues({ ...value, month: e.target.value })}
                disabled={isApplied}
              />
              <label htmlFor="last month">Previous Month</label>
            </div>
          </div>
          <div className="item6">
            <div className="toggle-radio">
              <input
                type="radio"
                id="month to date"
                name="month"
                value="Month to Date"
                checked={value.month === "Month to Date"} // Ensures "Month to Date" is selected by default
                onChange={(e) => setValues({ ...value, month: e.target.value })}
                disabled={isApplied}
              />
              <label htmlFor="month to date">Month to Date</label>
            </div>
          </div>
          <div className="item7">
            <div className="toggle-radio">
              <input
                type="radio"
                id="week to date"
                name="month"
                value="Week to Date"
                checked={value.month === "Week to Date"}
                onChange={(e) => setValues({ ...value, month: e.target.value })}
                disabled={isApplied}
              />
              <label htmlFor="week to date">Week to Date</label>
            </div>
          </div>
          <div className="item8">
            <div className="toggle-radio">
              <input
                type="radio"
                id="custom"
                name="month"
                value="Custom"
                checked={value.month === "Custom"}
                onChange={(e) => setValues({ ...value, month: e.target.value })}
                disabled={isApplied}
              />
              <label htmlFor="custom">Custom</label>
            </div>
          </div>
          {value.month === "Custom" && (
            <>
              <div className="item9">
                <FormInputs
                  type="date"
                  name="start_month"
                  value={value.start_month}
                  onChange={(e) =>
                    setValues({ ...value, start_month: e.target.value })
                  }
                  disabled={isApplied}
                />
              </div>
              <div className="item10">To</div>
              <div className="item11">
                <FormInputs
                  type="date"
                  name="end_month"
                  value={value.end_month}
                  onChange={(e) =>
                    setValues({ ...value, end_month: e.target.value })
                  }
                  disabled={isApplied}
                />
              </div>
            </>
          )}
        </div>
      </div>
      <div style={{ position: "relative", marginTop: "20px" }}>
        <button
          style={{
            position: "absolute",
            top: "-1px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 1,
            width: "60px",
            height: "10px",
            backgroundColor: "white",
            border: "none",
          }}
          onClick={() => {
            setIsExpanded(!isExpanded); // Toggle the isExpanded state when clicked
            setIsVisible(!isVisible);
          }}
        >
          <p style={{ fontSize: "20px", color: "black" }}>...</p>
        </button>
        <TableCompoenent
          headers={headers.map((header) => header.substring(2))}
          data={resultsData}
          searchPlaceholder="Search by Student Name..."
          isColumnDivVisible={isColumnDivVisible}
          setIsColumnDivVisible={setIsColumnDivVisible}
          dataClient={dataClient}
          ReportPageHeader={reportName}
          course={course}
          batch={getSelectedBatchNames()}
          subject={getSelectedSubjectNames()}
          chapter={getSelectedChapterNames()}
          dppName={""}
          student={getSelectedStudentRollNumbers()}
          date={
            from_date &&
            end_date &&
            dayjs(from_date).isValid() &&
            dayjs(end_date).isValid()
              ? `${dayjs(from_date).format("YYYY-MM-DD")} To ${dayjs(
                  end_date
                ).format("YYYY-MM-DD HH:mm:ss")}`
              : ""
          }
          isExpanded={isExpanded} // Pass the new isExpanded prop
        />
      </div>
    </div>
  );
};

export default DPPPerformance;
